import { useIsLoggedInToMyRac } from "raci-react-library";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { uploadInvoiceErrorRoutes, uploadInvoicePreFormRoutes } from "../../routing/uploadInvoiceRoutes.config";
import { useBffApiClient } from "../useApiClient";

export const useGetWebChatInformation = () => {
  const apiClient = useBffApiClient();
  const location = useLocation();
  const isAuthenticated = useIsLoggedInToMyRac();
  const [pointOfContactId, setPointOfContactId] = useState("");
  const [getShouldRenderWebChat, setShouldRenderWebChat] = useState(false);
  const [getCrmId, setCrmId] = useState("");

  const disallowPages = [
    ...uploadInvoicePreFormRoutes.map((route) => route.path),
    ...uploadInvoiceErrorRoutes.map((route) => route.path),
  ];
  const currentLocation = location.pathname.toLowerCase();

  const shouldGetWebChatInformation = isAuthenticated && !disallowPages?.includes(currentLocation);

  useEffect(() => {
    let isCancelled = false;
    const getWebChatId = async () => {
      try {
        if (!isCancelled) {
          if (shouldGetWebChatInformation) {
            const response = await apiClient.getWebChatContactId();
            setPointOfContactId(response.result.pointOfContactId ?? "");
            setCrmId(response.result.crmId ?? "");
            setShouldRenderWebChat(true);
          } else {
            setShouldRenderWebChat(false);
          }
        }
      } catch {
        setPointOfContactId("");
        setShouldRenderWebChat(false);
      }
    };

    getWebChatId();

    return () => {
      isCancelled = true;
    };
  }, [apiClient, currentLocation, shouldGetWebChatInformation]);

  return {
    pointOfContactId: pointOfContactId,
    crmId: getCrmId,
    shouldRender: getShouldRenderWebChat,
  };
};

export default useGetWebChatInformation;
